/**
 * KARKHANA — scroll reveal + progress bar + flat-lay tap-to-reveal.
 * Progressive enhancement only: all content is fully visible/readable
 * without this script running (see .kk-js gate in karkhana.css).
 */
(function () {
  function initScope(scope) {
    scope.classList.add('kk-js');

    var revealEls = Array.prototype.slice.call(scope.querySelectorAll('[data-kk-reveal]'));
    if ('IntersectionObserver' in window && revealEls.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('kk-revealed');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('kk-revealed'); });
    }

    var bar = scope.querySelector('.kk-progress-track__bar');
    if (bar) {
      var onScroll = function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        bar.style.width = (h > 0 ? Math.min(100, (window.scrollY / h) * 100) : 0) + '%';
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  document.querySelectorAll('.kk-scope').forEach(initScope);

  /**
   * Flat-lay cover cards: on hover-capable devices the CSS handles the
   * crossfade on its own. On touch devices (no real hover), the first tap
   * reveals the real product photo instead of navigating; a second tap (or
   * a tap on an already-revealed card) follows the link normally. Tapping
   * anywhere else clears any revealed card.
   */
  var noHover = window.matchMedia && window.matchMedia('(hover: none)').matches;
  if (noHover) {
    document.addEventListener('click', function (e) {
      var card = e.target.closest ? e.target.closest('.kk-crafted__card--has-flatlay') : null;
      if (card) {
        if (!card.classList.contains('is-touched')) {
          e.preventDefault();
          document.querySelectorAll('.kk-crafted__card--has-flatlay.is-touched').forEach(function (c) {
            if (c !== card) c.classList.remove('is-touched');
          });
          card.classList.add('is-touched');
        }
        return;
      }
      document.querySelectorAll('.kk-crafted__card--has-flatlay.is-touched').forEach(function (c) {
        c.classList.remove('is-touched');
      });
    });
  }
})();
